<template>
    <div>
        <v-row justify="center">
            <v-col>
                <div class="view-title" v-html="title"></div>
            </v-col>
        </v-row>
        <div v-for="block in blocks" :key="block.id">
            <TextBlock v-if="block.type == 'text'" :block="block"></TextBlock>
            <links-block v-if="block.type == 'links'" :block="block"></links-block>
            <youtube-block v-if="block.type == 'youtube'" :block="block"></youtube-block>
            <list-block v-if="block.type == 'list'" :block="block"></list-block>
            <items-block v-if="block.type == 'items'" :block="block"></items-block>
            <HtmlBlock v-if="block.type == 'html'" :block="block"></HtmlBlock>
        </div>
    </div>
</template>

<script>
    import {HTTP} from "../axios";
    import TextBlock from "../components/PageViewer/TextBlock";
    import LinksBlock from "../components/PageViewer/LinksBlock";
    import YoutubeBlock from "../components/PageViewer/YoutubeBlock";
    import ListBlock from "../components/PageViewer/ListBlock";
    import ItemsBlock from "../components/PageViewer/ItemsBlock";
    import HtmlBlock from "@/components/PageViewer/HtmlBlock";

    export default {
        name: "PageViewer",
        components:{
            HtmlBlock,
            TextBlock,
            LinksBlock,
            YoutubeBlock,
            ListBlock,
            ItemsBlock
        },
        data(){
            return{
                loading: false,
                title: "",
                blocks: [],
                snackbar: {
                    text: "",
                    value: false
                }
            }
        },
        methods:{
            update(){
                this.loading = true
                const path = this.$route.fullPath.slice(1);
                const path2 = this.$route.fullPath.split('/');

                console.log('Sliced '+path)
                console.log('Sliced2 '+path2)
                console.log('fullPath '+this.$route.fullPath)
                HTTP
                    .get(`pages?pageurl=${path}`)
                    .then(r => {
                        if(r.data.page.is_public == 0){

                            this.$router.replace('/404')
                        }
                        this.blocks = JSON.parse(r.data.page.data)
                        this.title = r.data.page.title
                        this.loading = false
                    })
                    .catch(e => {
                        if(e.response.status == 404){
                            this.$router.replace('/404')
                        }
                    })
            }
        },
        mounted() {
            this.update()
        }
    }
</script>

<style scoped>
    .view-title{
        font-size: 40px;
        color: #18224b;
        line-height: 1.23;
        font-family: 'PT Sans',Arial,sans-serif;
        font-weight: 600;
        padding: 20px 0 60px 0;
        text-align: center;
    }
</style>
